module.exports = __webpack_public_path__ + "static/img/close_icon.aef6e283.png";